import { useEffect, useState } from "react";
import React from "react";
import * as Icon from "react-bootstrap-icons";
import { Button, Form } from "react-bootstrap";

type saveCommentParams = {
	comment: string;
	poleAction: boolean;
	poleCommentId: string | null;
	isResolved: boolean;
}

interface commentFormParams {
	comment: saveCommentParams;
	onSubmitComment: (comment: saveCommentParams) => void;
	setActiveEditComment?: (commentId: string | null) => void;
}

export const CommentForm: React.FC<commentFormParams> = ({ comment, onSubmitComment, setActiveEditComment }: commentFormParams) => {
	const [commentInput, setCommentInput] = useState(comment.comment);
	const [isInvalidComment, setInvalidComment] = useState(false);

	useEffect(() => {
		if (isInvalidComment && commentInput.trim() !== '') setInvalidComment(false);
	}, [commentInput])

	const onSubmit = (e) => {
		e.preventDefault();
		if (commentInput.trim() === '') {
			setInvalidComment(true);
		} else if (commentInput.trim() !== comment.comment) {
			comment.comment = commentInput.trim();
			onSubmitComment(comment);
		} else {
			setActiveEditComment(null);
		}
	}

	return (
		<>
			<Form
				data-testid="CommentForm"
				className="form mx-2 my-2" id="form"
				onSubmit={(e) => onSubmit(e)}
			>
				<Form.Group>
					<Form.Control
						as="textarea"
						rows={2}
						className="comment-input pe-4"
						data-testid="comment-textarea"
						value={commentInput}
						onChange={(e) => {
							setCommentInput(e.target.value);
						}}
						placeholder="Enter comment"
						onKeyDown={(e) => {
							if (e.key === 'Enter') onSubmit(e)
						}}
					/>
					<div className="position-relative text-end">
						<Button className="bg-transparent border-0 p-0 position-absolute shadow-none" data-testid="send-icon" type="submit" style={{ bottom: '0', right: '0' }}>
							<Icon.SendFill className="icon send-icon" id="icon" />
						</Button>
					</div>
				</Form.Group>
				{isInvalidComment && <div className="label text-danger" data-testid="invalid-comment-error">Please enter a valid comment</div>}
			</Form>
		</>
	)
} 
